export default "__VITE_ASSET__C7tVi7mr__"